import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "../locales/fr.json";
import en from "../locales/en.json";
import ar from "../locales/ar.json";

export const SUPPORTED_LANGUAGES = ["fr", "en", "ar"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    saveMissing: false,
    missingKeyHandler: () => {},
    parseMissingKeyHandler: (key) => key,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "dashboardLanguage",
    },
  });

export const isRtlLanguage = (lng = i18n.language) =>
  (lng || "").startsWith("ar");

export default i18n;
